
import React, { Component } from 'react';
import AddressParser from '../../app/User/SelectDeliveryLocation/src/AddressParser';
import { GroupList } from "../components/index";
import SlideShowBanner from '../components/SlideShowBanner';
import AdvertisementBanner from '../../Model/AdvertisementBanner';

const _mpAddressBookmarkKey = "mp_address_bookmark"
class BookmarkAddressLocalStorage {
    static get() {
        return JSON.parse(localStorage.getItem(_mpAddressBookmarkKey) || "[]")
    }
    static set(bookmarks) {
        localStorage.setItem(_mpAddressBookmarkKey, JSON.stringify(bookmarks))
    }
}

// omp = Orderlah Marketplace
const _marketplaceRedirectKey = "source=omp"

export class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            merchantList: [],
            merchantListClone: [],
            merchantId: this.props.match && this.props.match.params ? this.props.match.params.merchant_id : undefined,
            submerchantList: [],
            selectedOutlet: undefined,
            selectedAddress: "",
            gautocompleteInput: "",
            gautocompleteSearchResult: [],
            bookmarkAddress: BookmarkAddressLocalStorage.get(),
            page: "home",
            pinLocation: {
                title: "",
                address: "",
                full_address: ""
            },
            searchRestaurant: "",
            geoData: [],
            mainStyle: {},
            searchType: "FNB",
            errorMessage: "",
            merchantType: [],
            advertisementBanners: [],
            initAction: "LOCATING"
        }
        this.resizeScreen = this.resizeScreen.bind(this);
    }

    componentDidMount() {
        this.getMerchantType();
        const urlParams = new URLSearchParams(window.location.search);
        const searchParam = urlParams.get('s');
        const typeParam = urlParams.get('t');
        this.setState({
            searchRestaurant: searchParam == null ? "" : searchParam,
            searchType: typeParam == null ? this.state.searchType : typeParam
        }, () => {
            const coordinateParam = urlParams.get('coordinate');
            if (coordinateParam == null) {
                this.sensorGetCoords();
            } else {
                const address = urlParams.get('address');
                const coord = coordinateParam.split(',');
                this.getDefaultMerchant([
                    coord[0],
                    coord[1],
                    address
                ]);
            }
        });

        this.loadBanners()
        window.addEventListener("resize", this.resizeScreen());
    }

    loadBanners = () => {
        $.ajax({
            url: '/api/marketplace/advertisement_banners',
            type: 'get',
            success: (responses) => {
                if (responses && Array.isArray(responses)) {
                    this.setState({
                        advertisementBanners: responses.map((adBanner) => this.buildAdvertisementBannerDto(adBanner)),
                    });
                }
            }
        })
    }

    getCoordinates() {
        return new Promise(function (resolve, reject) {
            navigator.geolocation.getCurrentPosition(resolve, reject);
        });
    }

    splitAddress(keyword) {
        return keyword.replace(/\,/, '_').split('_')
    }

    searchRestaurant(evt) {
        let keyword = evt.target.value;
        this.searchRestaurantService(keyword);
    }

    getMerchantType() {
        $.ajax({
            url: '/api/marketplace/merchant/getMerchantType',
            type: 'get',
            success: (responses) => {
                if (responses && Array.isArray(responses)) {
                    this.setState({
                        merchantType: responses,
                    });
                }
            }
        })
    }

    searchRestaurantService(keyword) {
        var filterMerchantList = [];

        if (keyword == "") {
            filterMerchantList = this.state.merchantList;
        } else {
            keyword = keyword.toLowerCase();
            this.state.merchantList.map((merchant) => {
                if (merchant.title.toLowerCase().search(keyword) > -1) {
                    filterMerchantList.push(merchant);
                } else if (merchant.address.toLowerCase().search(keyword) > -1) {
                    filterMerchantList.push(merchant);
                } else if (merchant.subtitle.toLowerCase().search(keyword) > -1) {
                    filterMerchantList.push(merchant);
                } else {
                    let added = false;
                    merchant.tag.map((tag) => {
                        if (!added && tag.toLowerCase().search(keyword) > -1) {
                            filterMerchantList.push(merchant);
                            added = true;
                        }
                    })
                }
            });
        }
        this.setState({
            merchantListClone: filterMerchantList,
            searchRestaurant: keyword
        });

    }

    async sensorGetCoords() {
        await this.getCoordinates().then((position) => {
            return new Promise((resolve, reject) => {
                let latitude = position.coords.latitude;
                let longitude = position.coords.longitude;
                let streetNumber = "";
                var address = "";


                let geocoder = new google.maps.Geocoder();
                var latlng = { lat: latitude, lng: longitude }
                geocoder.geocode({ 'location': latlng }, function (results, status) {
                    if (status == 'OK') {
                        if (results.length > 0) {
                            let addressParser = new AddressParser([results[0]])
                            address = results[0].formatted_address;
                            streetNumber = addressParser.getStreetNumber() || ""
                        }
                    } else {
                        alert('Geocode was not successful for the following reason: ' + status);
                        throw "Geocode was not successful"
                    }
                    resolve([latitude, longitude, address, streetNumber])
                });
            })
        }).then((data) => {
            this.setState({
                initAction: ""
            });
            this.getDefaultMerchant(data);
        }).catch(() => {
            this.setState({
                initAction: "ERROR_LOCATE"
            });
        });
    }

    async getDefaultMerchant(data) {
        await this.getMerchant(data[0], data[1], data[2]);
        if (this.state.initAction !== "ERROR_LOCATE") {
            const address = this.splitAddress(data[2]);
            this.setState({
                pinLocation: {
                    title: address[0],
                    address: address[1],
                    full_address: data[2]
                },
                initAction: "",
                geoData: data,
                selectedAddress: data[2]
            });
        }
    }

    getAddressCoord(address, placeId) {
        let latitude = "";
        let longitude = "";
        let streetNumber = "";
        let geocodeParams = placeId ? { placeId: placeId } : { address: address }
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode(geocodeParams, async (results, status) => {
            if (status == 'OK') {
                if (results.length > 0) {
                    let addressParser = new AddressParser([results[0]])
                    address = results[0].formatted_address
                    latitude = results[0].geometry.location.lat()
                    longitude = results[0].geometry.location.lng()
                    streetNumber = addressParser.getStreetNumber() || ""
                }
                let data = [latitude, longitude, address, streetNumber];

                await this.getMerchant(data[0], data[1], data[2]);
                if (this.state.initAction !== "ERROR_LOCATE") {
                    this.setState({
                        initAction: "",
                        geoData: data,
                        selectedAddress: data[2]
                    })
                }
            } else {
                alert('Geocode was not successful for the following reason: ' + status);
            }
        });
    }

    getCompleteAddress(input) {
        return new Promise(function (resolve, reject) {
            var service = new google.maps.places.AutocompleteService();
            var request = {
                input: input,
                componentRestrictions: { country: ["MY"] },
            };
            service.getPredictions(request, resolve, reject);
        });
    }

    autocompleteAddress(event) {
        var input = event.target.value;
        this.setState({
            gautocompleteInput: event.target.value
        });
        this.getCompleteAddress(input)
            .then((predictions) => {
                var predictionsList = [];
                predictions && predictions.forEach(function (prediction) {
                    const address = prediction.description.replace(/\,/, '_').split('_');
                    predictionsList.push({
                        "title": address[0],
                        "address": address[1],
                        "full_address": prediction.description,
                        "place_id": prediction.place_id,
                    })
                });
                this.setState({
                    gautocompleteSearchResult: predictionsList
                })
            })
    }

    buildAdvertisementBannerDto(advertisementBanner) {
        // Update redirect url to "http://.......?key1=val1&key2=val2&source=[_marketplaceRedirectKey]"
        let url = advertisementBanner.url
        if (url) {
            if (url.includes("?")) {
                url += _marketplaceRedirectKey
            }
            else {
                url += "?" + _marketplaceRedirectKey
            }
        }
        return Object.assign(new AdvertisementBanner(), {
            id: advertisementBanner.id,
            merchant_id: advertisementBanner.merchant_id,
            image_path: advertisementBanner.image_path,
            storage_url: advertisementBanner.storage_url,
            url: url,
            marketplace_sequence: advertisementBanner.marketplace_sequence,
        })
    }
    onBannerClicked = (bannerItem) => {
        if (bannerItem.url) {
            let geodata = this.state.geoData;
            const timestamp = Math.round((new Date()).getTime() / 1000)
            let url = bannerItem.url
            if (!url.includes("?")) {
                // Assume url = https://domain.com/foo/bar/
                // Convert to https://domain.com/foo/bar/?
                url += "?"
            }
            else {
                // Assume url = https://domain.com/foo/bar/?param1=value1
                // Convert to https://domain.com/foo/bar/?param1=value1&
                url += "&"
            }

            if (geodata && geodata.length > 0) {
                url += `coordinate=${geodata[0]},${geodata[1]}&address=${geodata[2]}&street_number=${geodata[3]}&${_marketplaceRedirectKey}&t=${timestamp}`
            }
            else {
                url += `${_marketplaceRedirectKey}&t=${timestamp}`
            }
            window.open(url, "_blank")
        }
    }
    buildMerchantDto(merchant) {
        return {
            id: merchant.id,
            title: merchant.name,
            subtitle: merchant.merchant_description,
            distance: merchant.distance,
            distanceDisplay: merchant.distance_display,
            image: merchant.display_logo,
            tableqr: base_url + merchant.tableqr,
            hasSubmerchant: merchant.has_submerchant,
            tag: merchant.tag,
            address: merchant.address,
            isOperating: merchant.is_operating,
            isAllowPreOrder: merchant.is_allow_pre_order,
            imageTag: !merchant.is_operating ? (!merchant.is_allow_pre_order ? "closing now" : "Pre-order") : ""
        };
    }

    getMerchant(latitude, longitude, address) {
        if (isNaN(latitude) || isNaN(longitude)) {
            this.setState({
                initAction: "ERROR_LOCATE"
            });
        } else {
            this.setState({
                isLoadingMerchant: true
            })
            $.ajax({
                url: '/api/marketplace/merchant/get?lat=' + latitude + "&long=" + longitude + "&address=" + address + "&t=" + this.state.searchType,
                type: 'get',
                success: (responses) => {
                    if (responses && Array.isArray(responses)) {
                        let merchants = []
                        responses.forEach((merchant) => {
                            merchants.push(this.buildMerchantDto(merchant));
                        })
                        this.setState({
                            initAction: "",
                            merchantList: merchants,
                            merchantListClone: merchants
                        }, () => {
                            this.searchRestaurantService(this.state.searchRestaurant);
                        });
                    }
                }
            })
                .always(() => {
                    this.setState({
                        isLoadingMerchant: false
                    })
                })
        }
    }

    getMerchantOutlet(id) {
        const geoData = this.state.geoData;
        $.ajax({
            url: '/api/marketplace/merchant/getOutlet/' + id + '?lat=' + geoData[0] + "&long=" + geoData[1] + "&address=" + geoData[2],
            type: 'get',
            success: (responses) => {
                if (responses && Array.isArray(responses)) {
                    let merchants = []
                    responses.forEach((merchant) => {
                        merchants.push(this.buildMerchantDto(merchant));
                    })
                    this.setState({
                        submerchantList: merchants
                    });
                }
            }
        })
    }

    _redirectToShop(item) {
        if (item.isOperating || item.isAllowPreOrder) {
            if (item.hasSubmerchant) {
                this.setState({
                    merchantId: item.id,
                    selectedOutlet: item
                }, () => {
                    this.getMerchantOutlet(item.id);
                });
            } else {
                let geodata = this.state.geoData;
                var timestamp = Math.round((new Date()).getTime() / 1000)
                window.location = item.tableqr + `?coordinate=${geodata[0]},${geodata[1]}&address=${geodata[2]}&street_number=${geodata[3]}&${_marketplaceRedirectKey}&t=${timestamp}`
            }
        }
    }

    _backToHome() {
        this.setState({
            merchantId: undefined,
            selectedOutlet: undefined,
            page: "home"
        });
    }

    _selectBookmarkAddress(item) {
        const bookmarks = this.state.bookmarkAddress;
        let found = false;
        bookmarks.map((bookmark) => {
            if (bookmark.full_address == item.full_address) {
                found = true;
            }
        })
        if (!found) {
            bookmarks.push(item);
        }
        BookmarkAddressLocalStorage.set(bookmarks)
        this.getAddressCoord(item.full_address, item.place_id);
        this.setState({
            gautocompleteInput: "",
            bookmarkAddress: bookmarks,
            gautocompleteSearchResult: [],
            page: "home",
            selectedAddress: item.full_address,
            merchantId: undefined,
            selectedOutlet: undefined,
        });
    }

    searchAddress(page) {
        this.setState({
            page: page
        })
    }

    resizeScreen() {
        this.setState({
            mainStyle: {
                "maxHeight": window.innerHeight,
                "overflowY": "scroll",
                "overflowX": "hidden"
            }
        });
    }

    selectMerchantType(type) {
        let data = this.state.geoData;
        this.setState({
            searchType: type
        }, async () => {
            await this.getMerchant(data[0], data[1], data[2]);
        });
    }

    merchantList = () => {
        const { merchantListClone, merchantId, isLoadingMerchant, submerchantList } = this.state
        if (isLoadingMerchant) {
            return <div style={{ textAlign: "center", marginTop: "30px" }}>
                Loading <span className="fa fa-spinner fa-spin"></span>
            </div>
        }
        else if (merchantListClone.length) {
            return <GroupList
                listClick={this._redirectToShop.bind(this)}
                list={
                    merchantId == undefined ? merchantListClone : submerchantList
                } />
        }
        return null
    }

    render() {
        const { merchantListClone, merchantId, submerchantList, selectedOutlet,
            selectedAddress, gautocompleteSearchResult, bookmarkAddress, page,
            pinLocation, mainStyle, errorMessage, merchantType, searchType, initAction } = this.state;
        return <div>
            {
                page == "search" &&
                <main className={"entry fixed-wrapper fixed-wrapper__main"} style={mainStyle}>
                    <section className={"deliver_to__label sticky-wrapper"}>
                        <div className={"deliver-to-entry__content"}>
                            <div className={'row'}>
                                <div className={"col-md-2"} style={{ "paddingLeft": "5px", "paddingTop": "8px" }}>
                                    <i className="header__icon"
                                        onClick={(evt) => { this.searchAddress("home", evt) }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"></path><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path></svg></i>

                                </div>
                                <div className={"col-md-9"} style={{ "marginLeft": selectedAddress == "" ? "10px" : "5px" }}>
                                    <label className={"deliver_to__label search_deliver__label text-uppercase text-weight-bold"}>
                                        Deliver To</label>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="entry-home fixed-wrapper__container wrapper">
                        <div className="padding-left-right-normal entry-home__banner">
                            {
                                merchantId == undefined &&
                                <div className="entry-home__search">
                                    <div className="form__group flex flex-middle">
                                        <i className="icon icon__normal icon__gray">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                                <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path><path d="M0 0h24v24H0z" fill="none"></path>
                                            </svg>
                                        </i>
                                        <input className="form__input" type="type"
                                            placeholder="Search your address" value={this.state.gautocompleteInput}
                                            onChange={this.autocompleteAddress.bind(this)} />
                                    </div>
                                </div>
                            }
                        </div>

                        <div>
                            {
                                gautocompleteSearchResult.length > 0 &&
                                gautocompleteSearchResult.map((result) => {
                                    return <div className="location-picker__detected-position"
                                        onClick={(evt) => { this._selectBookmarkAddress(result, evt) }}
                                        key={result.full_address}>
                                        <div className="location-picker__detected-position-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M19 18l2 1V3c0-1.1-.9-2-2-2H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13zM15 5H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2z"></path></svg>
                                        </div>
                                        <div className="location-picker__detected-position-address">
                                            <div>
                                                <div className="location-picker__address-item">
                                                    <div className="location-picker__address-title">{result.title}</div>
                                                    <div className="location-picker__address-detail">
                                                        <span>{result.address}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }

                            {
                                gautocompleteSearchResult.length == 0 &&
                                <div className="location-picker__detected-position"
                                    onClick={(evt) => { this._selectBookmarkAddress(pinLocation, evt) }}>
                                    <div className="location-picker__detected-position-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path>
                                        </svg>
                                    </div>
                                    <div className="location-picker__detected-position-address">
                                        <div>
                                            <div className="location-picker__address-item">
                                                <div className="location-picker__address-title">{pinLocation.title}</div>
                                                <div className="location-picker__address-detail">
                                                    <span>{pinLocation.address}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                gautocompleteSearchResult.length == 0 &&
                                bookmarkAddress.map((result) => {
                                    return <div className="location-picker__detected-position"
                                        onClick={(evt) => { this._selectBookmarkAddress(result, evt) }}
                                        key={result.full_address}>
                                        <div className="location-picker__detected-position-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M19 18l2 1V3c0-1.1-.9-2-2-2H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13zM15 5H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2z"></path></svg>
                                        </div>
                                        <div className="location-picker__detected-position-address">
                                            <div>
                                                <div className="location-picker__address-item">
                                                    <div className="location-picker__address-title">{result.title}</div>
                                                    <div className="location-picker__address-detail">
                                                        <span>{result.address}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                            <div className="mt-2" style={{ float:"right" }}>
                                <img src="/image/powered_by_google_on_white.png"/>
                            </div>
                        </div>

                    </section>
                </main>
            }
            {
                page == "home" &&
                <main className={"entry fixed-wrapper fixed-wrapper__main"} style={mainStyle}>
                    <section className={"deliver-to-entry deliver_to__label sticky-wrapper"}>
                        <div className={"deliver-to-entry__content"}>
                            <div className={'row'}>
                                <div className={selectedAddress == "" ? "col-md-2 col-sm-1 col-1" : "col-md-1 col-sm-1 col-1"} style={{ "paddingLeft": "5px", "paddingTop": "5px" }}>
                                    {
                                        merchantId == undefined &&
                                        <figure className="entry-home__banner-image">
                                            <img src="/image/orderlah_logo_640.png" alt="mvp home banner logo"></img>
                                        </figure>
                                    }
                                    {
                                        merchantId !== undefined &&
                                        <i className="header__icon"
                                            onClick={(evt) => this._backToHome(evt)}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"></path><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path></svg></i>
                                    }
                                </div>
                                <div className={"col-md-9 col-sm-9 col-xs-9 headerAddress " + (selectedAddress == "" ? "empty-address" : "")}
                                    onClick={(evt) => { this.searchAddress("search", evt) }}>
                                    <label className={"deliver_to__label text-uppercase text-weight-bold"}>
                                        Deliver To</label>
                                    <div>
                                        <i className={"icon icon__small icon__gray text-middle"}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>
                                        </i>
                                        <span className={"deliver-to-entry__address text-middle text-opacity text-omit__single-line"}>{selectedAddress}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="entry-home fixed-wrapper__container wrapper">
                        <div>
                            <SlideShowBanner bannerItems={this.state.advertisementBanners} onBannerClicked={this.onBannerClicked} />
                        </div>
                    </section>
                    <section className="entry-home fixed-wrapper__container wrapper">
                        <div className="site-banner padding-left-right-normal entry-home__banner">
                            {
                                merchantId == undefined &&
                                <div className="entry-home__search">
                                    <div className="form__group flex flex-middle">
                                        <i className="icon icon__normal icon__gray">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                                <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path><path d="M0 0h24v24H0z" fill="none"></path>
                                            </svg>
                                        </i>
                                        <input className="form__input" type="type"
                                            placeholder="Search for a restaurant" value={this.state.searchRestaurant}
                                            onChange={(evt) => this.searchRestaurant(evt)} />
                                    </div>
                                </div>
                            }
                        </div>

                        <div className={"padding-normal"}>
                            <ul className="flex padding-top-bottom-normal"
                                style={{ "paddingLeft": "0px" }}>
                                {
                                    merchantId == undefined &&
                                    merchantType.length > 0 &&
                                    merchantType.map((item, index) => {
                                        return <li key={index} className="store-collections__item text-center" onClick={(evt) => { this.selectMerchantType(item.type_code, evt) }}>
                                            <img src={item.icon_path} alt={item.type_name}
                                                className={"icon merchantType " + (item.type_code == searchType ? "active" : "")}
                                            />
                                            <span className="store-collections__name text-size-smaller text-center text-weight-bolder">
                                                {item.type_name}
                                            </span>
                                        </li>
                                    })
                                }
                            </ul>
                            {
                                this.state.searchRestaurant !== "" &&
                                merchantListClone.length == 0 &&
                                <div className="text-center padding-top-bottom-normal" style={{ "paddingTop": "100px" }}>
                                    <p className="entry-home__prompt-text text-size-big text-opacity">
                                        Couldn't Find Results for "{this.state.searchRestaurant}"" Let's try a different restaurant.
                                </p>
                                </div>
                            }
                            {
                                merchantListClone.length > 0 &&
                                <h3 className={"text-size-biggest text-weight-bolder"}>
                                    {
                                        selectedOutlet ? selectedOutlet.title : "Restaurants Delivering Nearby"
                                    }
                                </h3>
                            }

                            {this.merchantList()}

                            {
                                initAction == "" &&
                                !this.state.isLoadingMerchant &&
                                this.state.searchRestaurant === "" &&
                                merchantListClone.length == 0 &&
                                <div className="text-center padding-top-bottom-normal" style={{ "paddingTop": "100px" }}>
                                    <p className="entry-home__prompt-text text-size-big text-opacity">
                                        {
                                            errorMessage == "" ?
                                                "No available restaurent nearby. Let's try a different location."
                                                : errorMessage
                                        }

                                    </p>
                                </div>
                            }
                            {
                                initAction == "LOCATING" &&
                                <div className="text-center padding-top-bottom-normal" style={{ "paddingTop": "100px" }}>
                                    <figure className={"search-location"}>
                                        <img src="/image/marketplace/search-location.gif" alt="search user location" />
                                    </figure>
                                    <p className="entry-home__prompt-text text-size-big text-opacity">
                                        Locating your current position
                                </p>
                                </div>
                            }

                            {
                                initAction == "ERROR_LOCATE" &&
                                <div className="text-center padding-top-bottom-normal" style={{ "paddingTop": "100px" }}>
                                    <p className="entry-home__prompt-text text-size-big text-opacity">
                                        Opss. We can't locate you.
                                </p>
                                    <button
                                        className={"search-address"}
                                        onClick={(evt) => { this.searchAddress("search", evt) }}>
                                        Search Your Address.
                                    </button>
                                </div>
                            }
                        </div>

                    </section>
                </main>
            }
        </div>
    }
}
